import React from 'react';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';

import 'echarts/lib/chart/map';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/visualMap';

import gannanMap from './gannanMap.json';

const gannanAnthraxCases = [
  { name: 'Hezuo City', value: [6, 2, 3, 4, 0, 0, 2, 1, 4, 3, 4, 3, 3, 3, 2] },
  { name: 'Lintan County', value: [0, 0, 2, 1, 0, 0, 0, 0, 0, 1, 0, 2, 2, 3, 0] },
  { name: 'Zhuoni County', value: [2, 0, 1, 2, 1, 0, 1, 0, 2, 2, 4, 0, 0, 3, 0] },
  { name: 'Maqu County', value: [32, 43, 41, 30, 40, 31, 45, 56, 63, 58, 55, 69, 60, 34, 18] },
  { name: 'Luqu County', value: [5, 3, 4, 6, 14, 5, 14, 7, 13, 15, 23, 25, 35, 12, 5] },
  { name: 'Xiahe County', value: [7, 6, 5, 16, 6, 2, 8, 4, 12, 15, 16, 9, 18, 12, 12] },
  { name: 'Diebu County', value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
  { name: 'Zhouqu County', value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
];

const gannanNameMap = {
  '合作市': 'Hezuo City',
  '临潭县': 'Lintan County',
  '卓尼县': 'Zhuoni County',
  '玛曲县': 'Maqu County',
  '碌曲县': 'Luqu County',
  '夏河县': 'Xiahe County',
  '迭部县': 'Diebu County',
  '舟曲县': 'Zhouqu County',
};

class OverallDistributionMap extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
    this.state = {
      startYear: 2005,
      endYear: 2019,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    if (parseInt(this.state.startYear) > parseInt(this.state.endYear)) {
      alert(`Invalid year range from ${this.state.startYear} to ${this.state.endYear}.`);
      return;
    } else {
      // update chart
      var updated_data = gannanAnthraxCases.map((item) => ({
        name: item['name'],
        value: item['value'].slice(this.state.startYear - 2005, this.state.endYear - 2004).reduce((a, b) => a + b, 0)
      }));
      this.myChart.setOption({
        series: {
          data: updated_data,
        }
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    echarts.registerMap('GannanMap', gannanMap);
    this.myChart = echarts.init(document.getElementById('overall-distribution-map'), 'customColorTheme', 'EN');
    var option = {
      animation: true,
      grid: {
        left: 'center',
        width: '70%',
        top: '3%',
        height: '80%',
      },
      tooltip: {
        trigger: 'item',
      },
      toolbox: {
        left: 'right',
        top: 'top',
        feature: {
          dataView: { readOnly: false },
          restore: {},
          saveAsImage: {}
        }
      },
      visualMap: {
        type: 'piecewise',
        realtime: false,
        calculable: true,
        pieces: [
          { min: 500, label: '>500' },
          { min: 200, max: 500, label: '200-500' },
          { min: 50, max: 200, label: '50-200' },
          { min: 20, max: 50, label: '20-50' },
          { min: 1, max: 20, label: '1-20' },
          { max: 1, label: '0', color: '#cccccc' }
        ],
        inRange: {
          color: ['#feedde', '#fdbe85', '#fd8d3c', '#e6550d', '#a63603']
        }
      },
      series: {
        name: 'Number of cases',
        type: 'map',
        roam: true,
        map: 'GannanMap',
        hoverAnimation: true,
        label: {
          show: true,
          position: 'right',
        },
        data: [
          { name: 'Hezuo City', value: 37 },
          { name: 'Lintan County', value: 11 },
          { name: 'Zhuoni County', value: 17 },
          { name: 'Maqu County', value: 648 },
          { name: 'Luqu County', value: 174 },
          { name: 'Xiahe County', value: 137 },
          { name: 'Diebu County', value: 0 },
          { name: 'Zhouqu County', value: 0 },
        ],
        nameMap: gannanNameMap
      }
    };
    this.myChart.setOption(option);
  }

  render() {
    var yearRange = Array.from({ length: 15 }, (_, i) => i + 2005);
    var startYearOptions = yearRange.map((x) => {
      if (x === this.state.startYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    var endYearOptions = yearRange.map((x) => {
      if (x === this.state.endYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    return (
      <>
        <form class="form-inline justify-content-center" style={{ 'margin-bottom': '30px' }}>
          <div class="form-group" style={{ 'padding-right': '25px' }}>
            <label style={{ 'padding-right': '10px' }}>Start Year</label>
            <select class="form-control" name="startYear" onChange={this.handleInputChange}>
              {startYearOptions}
            </select>
          </div>
          <div class="form-group" style={{ 'padding-right': '25px' }}>
            <label style={{ 'padding-right': '10px' }}>End Year</label>
            <select class="form-control" name="endYear" onChange={this.handleInputChange}>
              {endYearOptions}
            </select>
          </div>
          <button type="button" class="btn btn-outline-secondary" onClick={this.handleSubmit}>Submit</button>
        </form>
        <div class="m-auto" id="overall-distribution-map" style={{ height: '600px' }}></div>
      </>
    );
  }
}

export default OverallDistributionMap;